import { IConfiguration } from '../models/app/IConfiguration';

export const CONFIGURATION: IConfiguration = {
	components: {
		app: {
			gridProps: {
				grid: {
					rows: [
						{
							columns: [
								{
									components: [
										{
											key: 'base.text',
											props: {
												value: 'test',
											},
										},
									],
								},
							],
						},
					],
				},
			},
		},
	},
};
